import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  RedirectCommand,
  UrlTree,
  CanActivateFn,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { ToasterService } from '../../services/toaster.service';

export const AuthGuardFxn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  const translateService = inject(TranslateService);

  const isAuthenticated = authService.isAuthenticated();
  const isLoginPage = state.url.includes('/auth/login');

  if (isLoginPage && isAuthenticated) {
    const tree: UrlTree = router.createUrlTree(['/dashboard']);
    return tree;
  }

  if (!isLoginPage && !isAuthenticated) {
    // Show toast as a side-effect before redirect
    toasterService.showError(translateService.instant('LoginFirst'));

    // If NavigationExtras are desired (e.g., queryParams, replaceUrl), use RedirectCommand (Angular 18)
    const tree: UrlTree = router.createUrlTree(['/auth/login'], {
      queryParams: { redirectUrl: state.url },
    });

    // Example with NavigationExtras using RedirectCommand (Angular 18)
    return new RedirectCommand(tree, { replaceUrl: true });
  }

  return true;
};
